import { ReactNode } from 'react';

import LockIcon from '@ping/assets/Icon/lock.svg';

import { marketsKeys } from '../helpers';

export const coinTabOptions = (
  pairs: [string, IMarketModified[]][],
  icon: ReactNode,
  showFav: boolean,
  isContractSigned?: (assetId: string) => boolean
) => {
  return [
    { value: marketsKeys.ALL_MARKETS, view: marketsKeys.ALL_MARKETS },
    ...(showFav ? [{ value: marketsKeys.FAVORITE_MARKETS, view: icon }] : []),
    ...pairs.map(([coinKey]) => {
      const isUnsigned = isContractSigned ? !isContractSigned(coinKey.toUpperCase()) : false;

      return {
        value: coinKey,
        view: isUnsigned ? (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
            {coinKey.toUpperCase()}
            <LockIcon style={{ width: 10, height: 10, color: '#ffa500' }} />
          </span>
        ) : (
          coinKey.toUpperCase()
        ),
      };
    }),
  ];
};
